import { useQuery } from '@tanstack/react-query';

import { fetchCurrentUser } from '../api/auth.api';

export const AUTH_KEYS = {
  me: ['auth', 'me'] as const,
};

export function useCurrentUser() {
  return useQuery({
    queryKey: AUTH_KEYS.me,
    queryFn: fetchCurrentUser,
    retry: false,
  });
}
